/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import PropTypes from 'prop-types';
import Campaign from './Campaign';

function CampaignContainer(props) {
  const { match } = props;
  const { artistId, offerId } = match.params;
  return (
    <Campaign offerId={offerId} artistId={artistId} />
  );
}

CampaignContainer.propTypes = {
  match: PropTypes.object.isRequired,
};

export default CampaignContainer;
